import React, { useState } from "react";

import SearchIcon from "@mui/icons-material/Search";
import { Box, Button, InputAdornment, TextField } from "@mui/material";

import mainStyles from "../../styles";

type SearchBarProps = {
  setSearchVal: (newSearchVal: string) => void;
};

const SearchBar = ({ setSearchVal }: SearchBarProps) => {
  const classes = mainStyles();

  const [searchInp, setSearchInp] = useState("");

  const handleSearch = () => {
    setSearchVal(searchInp);
  };
  const clearSearch = () => {
    setSearchInp("");
    setSearchVal("");
  };

  return (
    <Box
      p={3}
      style={{ width: "100%", display: "flex" }}
      sx={classes.spaceSearchNoMargin}
    >
      <TextField
        variant="outlined"
        size="small"
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        inputProps={{
          "data-testid": "user-display-search-bar",
        }}
        value={searchInp}
        onChange={(e) => setSearchInp(e.target.value)}
        onKeyUp={(event) => {
          if (event.key === "Enter") {
            handleSearch();
          }
        }}
      />

      <Button
        variant="contained"
        color="primary"
        onClick={handleSearch}
        data-testid="user-display-search-bar-search-button"
      >
        Search
      </Button>
      <Button
        variant="contained"
        color="secondary"
        onClick={clearSearch}
        data-testid="user-display-search-bar-clear-button"
      >
        Clear
      </Button>
    </Box>
  );
};
export default SearchBar;
